import { IconStorage } from "@app/shared/icons/interfaces";

export const providerMapPin: IconStorage = {
  svgCode: () => ([
    "m 12,0.83494061 c -4.9330942,0 -8.9320642,3.99896999 -8.9320642,8.93206419 C 3.0679358,15.81664 9.7669616,18.699025 12,23.165101 14.233039,18.699025 20.932064,15.81664 20.932064,9.7670048 20.932064,4.8339106 16.933116,0.83494061 12,0.83494061 Z m 0,5.02444199 c 1.849961,0 3.349836,1.4993071 3.349836,3.3492122 0,1.8499612 -1.499875,3.3498362 -3.349836,3.3498362 -1.849961,0 -3.3498361,-1.499875 -3.3498361,-3.3498362 0,-1.8499051 1.4998751,-3.3492122 3.3498361,-3.3492122 z"
  ]),
};
